<template>
  <div style="position: relative;">
    <div :class="{ backgroundIndex: true }"><img :src="pic" /></div>

    <Head />
    <router-view />

    <Footer class="footer" />
  </div>
</template>

<script>
import Head from "./head";
import Footer from "./footer";
import { getHomePic, getpicCode } from "@/api/homeIndex.js";
import { getFileDetails } from "@/api/file";
export default {
  name: "index",
  components: {
    Head,
    Footer,
  },
  data () {
    return {
      scrollTopTo: false,
      pic: "",
    };
  },
  created () {
    // this.getPic("RES99B46888C07A671")
  },
  watch: {
    $route: {
      handler (val, oldVal) {
        let moduleCode = "RES99B46888C07A671";
        // 首页
        if (val.name === "home-index") {
          moduleCode = "RES99B46888C07A671";
        }
        // 机构概况
        if (val.name === "institutional-overview") {
          moduleCode = "RES521F7126AAF025E";
        }
        // 出国签证
        if (val.name === "goaboard") {
          moduleCode = "RESAEFA600C552956E";
        }
        // 领事认证
        if (val.name === "consular-certification") {
          moduleCode = "RES613F97EF763385C";
        }
        // 翻译服务
        if (val.name === "translation-service") {
          moduleCode = "RES0C713BFE746B846";
        }
        // 出国服务
        if (val.name === "service-abroad") {
          moduleCode = "RES0D5691F848476D2";
        }
        // 外企服务
        if (val.name === "foreign-company-service") {
          moduleCode = "RESB8DC80EAF54DD81";
        }
        // 联系我们
        if (val.name === "contactUs") {
          moduleCode = "RES5A0708708C7B424";
        }
        this.getPic(moduleCode);
      },
      deep: true,
      immediate: true,
    },
  },
  methods: {
    async getPic (moduleCode) {
      let picData = await getpicCode(moduleCode);
      let picCode = this._.get(picData, "data.records.0.picCode", "");
      let codeList = [];
      let pic = await getHomePic(picCode, "96F307B9D0EDF9F");
      let appCode = this._.get(pic, "data.appCode", "");
      let tenantCode = this._.get(pic, "data.tenantCode", "");
      codeList.push(
        this._.get(pic, "data.contentPicFileDtoList.0.fileCode", "")
      );
      // console.log('1', appCode, '2', tenantCode, '3', codeList);
      let list = await getFileDetails(appCode, tenantCode, codeList);
      let iList = [];
      iList.push(...Object.values(this._.get(list, "data", {})));
      this.pic = iList[0].fileHttpUrl;
      console.log(this.pic);
    },
  },
  // mounted() {
  //   window.addEventListener('scroll', this.handleScroll)
  // },
  // destroyed() {
  //   window.removeEventListener('scroll', this.handleScroll)
  // },
  // methods: {
  //   handleScroll() {
  //     let self = this
  //     let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
  //     if (scrollTop > 60) {
  //       self.scrollTopTo = true;
  //     } else {
  //       self.scrollTopTo = false;
  //     }
  //   },
  // }
};
</script>

<style scoped lang='less'>
.backgroundIndex {
  height: 520px;
  width: 100%;
 position: absolute;
  index: -2;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-position: center;
}
.backgroundIndex img {
  width: 100%;
  height: 100%;
}
//.imgShort {
//  height: 520px;
//  width: 100%;
//  position: absolute;
//  index: -2;
//  background-size: 100% 100%;
//  background-repeat: no-repeat;
//  background-position: center;
//}
</style>



// WEBPACK FOOTER //
// src/components/index/index.vue